import type { ComponentProps, PropsWithChildren, ReactNode } from 'react';

type ModalFooterProps = PropsWithChildren<ComponentProps<'div'>>;

/**
 * The modal footer wrapper.
 *
 * @param root0 input props
 * @param root0.children the children to pass down
 * @returns Footer wrapper
 */
export default function ModalFooter({ children, ...props }: ModalFooterProps): ReactNode {
  return <div {...props}>{children}</div>;
}
